export enum EPageType {
  DobroForm = 'DobroForm',
  DobroObjects = 'DobroObjects',
}
